module.exports = __webpack_public_path__ + "img/StarOutlineCopy.41561274.png";